import { URL_HELPER } from "../../App";
import {Asset} from "../../api";
import cartIcon from '../../assets/icons/shopping-cart.svg';
import closeIcon from '../../assets/icons/close.svg';

type CartItem = {
  id: number;
  name: string;
  extension: string;
  imageURL: string;
};

type SetCart = React.Dispatch<React.SetStateAction<Array<CartItem>>>;


function toggleCart(item: Asset | null = null, cart: Array<CartItem> = [], setCart: SetCart) {
  const cartItem = {
      id: item?.id || 0,
      name: item?.name || "",
      extension: item?.extension || "",
      imageURL: URL_HELPER.getThumbnailUrl() + "/" + item?.id
  };
  if (cart.length === 0) {
      setCart([cartItem]);
  } else if (cart.length > 0 && cart.find(((item) => cartItem.id === item.id))) {
      setCart(cart.filter((i: CartItem) => i.id !== cartItem.id));
  } else if (cart.length > 0) {
      setCart([...cart, cartItem]);
  }
}

function cartButtonText(asset: Asset | null = null, cart: Array<CartItem> = []) {
  if (itemAlreadyAddedToCart(asset, cart)) {
      return "Remove from cart";
  } else {
      return "Add to cart";
  }
}

function cartButtonIcon(asset: Asset | null = null, cart: Array<CartItem> = []) {
  if (itemAlreadyAddedToCart(asset, cart)) {
      return closeIcon;
  } else {
      return cartIcon;
  }
}

function itemAlreadyAddedToCart(asset: Asset | null = null, cart: Array<CartItem> = []) {
  return cart.find(((item) => asset?.id === item.id));
}

export { toggleCart, cartButtonText, cartButtonIcon, itemAlreadyAddedToCart };

export type { CartItem, SetCart };
